/* LA SELE. Premium Theme JS */

document.addEventListener('DOMContentLoaded', () => {
  // Reveal animations using Intersection Observer
  const revealElements = document.querySelectorAll('.ls-reveal');
  const sectionElements = document.querySelectorAll('.la-sele-section');
  
  // Observer for individual reveal elements
  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });

    revealElements.forEach(el => revealObserver.observe(el));
  }

  // Observer for full section transitions (the smooth fade-in between sections)
  if (sectionElements.length > 0) {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -5% 0px',
      threshold: 0.05
    });

    sectionElements.forEach(el => sectionObserver.observe(el));
  }
});
